import { Script } from "gatsby"
import React, { useEffect } from "react"

const TallyForm = ({ title, link }) => {
  // The code below will load the embed
  useEffect(() => {
    // const widgetScriptSrc = "https://tally.so/widgets/embed.js"
    // const load = () => {
    //   try {
    //     // Load Tally embeds
    //     if (typeof Tally !== "undefined") {
    //       Tally.loadEmbeds()
    //       return
    //     }
    //     // Fallback if window.Tally is not available
    //     document
    //       .querySelectorAll("iframe[data-tally-src]:not([src])")
    //       .forEach(iframeEl => {
    //         iframeEl.src = iframeEl.dataset.tallySrc
    //       })
    //   } catch (e) {
    //     console.log(e)
    //   }
    // }
    // try {
    //   // If Tally is already loaded, load the embeds
    //   if (typeof Tally !== "undefined") {
    //     load()
    //     return
    //   }
    // } catch (e) {
    //   console.log(e)
    // }
    // // If the Tally widget script is not loaded yet, load it
    // if (document.querySelector(`script[src="${widgetScriptSrc}"]`) === null) {
    //   const script = document.createElement("script")
    //   script.src = widgetScriptSrc
    //   script.onload = load
    //   script.onerror = load
    //   document.body.appendChild(script)
    //   return
    // }
  }, [])

  return (
    <>
      <iframe
        data-tally-src={link}
        loading="lazy"
        width="100%"
        height="1000"
        title={title}
      ></iframe>
      <Script src="https://tally.so/widgets/embed.js" />
    </>
  )
}

export default TallyForm
